import request from '@/request'
const part_url = '/train/web/mineRecruit/';

// 查询我的招聘列表
function getMineRecruitList(data) {
  let url = part_url + "list";
  return request.get(url,data)
}

// 查询我的招聘详细
function getMineRecruit(data) {
  let url = part_url + "getById";
  return request.get(url,data);
}

// 新增我的招聘
function MineRecruitAdd(data) {
  let url = part_url + "add";
  return request.post(url,{},data);
}

// 修改我的招聘
function MineRecruitEdit(data) {
  let url = part_url + "edit";
  return request.post(url,{}, data)
}

function MineRecruitDel(data){
  let url = part_url + "deleteById";
  return request.get(url,data)
}


export default {
  getMineRecruitList,
  getMineRecruit,
  MineRecruitAdd,
  MineRecruitEdit,
  MineRecruitDel,
}




// WEBPACK FOOTER //
// ./src/api/mineRecruit.js